export { useOrderChat } from "./useOrderChat";
export type { OrderChatState } from "./useOrderChat";
export { mergeMessages } from "./lib";
export {
  frameToMessage,
  isChatMessageFrame,
} from "./frames";
export type { ChatMessageFrame, OutgoingChatFrame } from "./frames";

/** Message posted when the user taps "Позвать продавца" (a normal chat message). */
export const CALL_SELLER_TEXT = "Здравствуйте! Подскажите, пожалуйста, по моему заказу.";

/** SLA hint shown under the chat (response window for the seller). */
export const SELLER_SLA_NOTE =
  "Продавец обычно отвечает в течение 10 минут. Если ответа нет — нажмите «Позвать продавца».";
